var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBcgLeftLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 920,
    viewBox: "0 0 960 920",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69273_33439",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 960,
    height: 920
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 920,
    fill: "#171B1F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69273_33439)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_69273_33439)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.9879,
    cy: 927.988,
    rx: 212.286,
    ry: 212.286,
    transform: "rotate(150 45.9879 927.988)",
    fill: "url(#paint0_radial_69273_33439)",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-191.822 1065.82C-267.759 934.295 -222.695 766.114 -91.1691 690.178C40.3563 614.241 208.537 659.305 284.473 790.831C360.41 922.356 315.346 1090.54 183.82 1166.47C52.2948 1242.41 -115.886 1197.35 -191.822 1065.82Z",
    stroke: "#3BD4AE",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_69273_33439",
    x: -216.333,
    y: 665.667,
    width: 524.643,
    height: 524.643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_69273_33439"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_69273_33439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.949 927.842) rotate(85.8843) scale(177.459 177.459)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BD4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcgLeftLogin);
export default __webpack_public_path__ + "static/media/bcg_left_login.db36cd114efee8f789bb55c79353f843.svg";
export { ForwardRef as ReactComponent };